<template>
    <main-layout>

        <!-- Wrapper avec dégradé bleu (header) -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <header class="text-white pt-4 pb-12 px-4 flex items-center justify-between">
                <!-- Titre + back -->
                <h1 class="text-2xl flex items-center gap-2">
                    <!-- Bouton retour façon Vite (id conservé, back Vue) -->
                    <a id="install_infos_btn_back" href="javascript:void(0)" @click="$router.back()">
                        <i class="inline-block h-12 w-12 mask mask-arrow-left bg-white"></i>
                    </a>
                    <span>Informations complémentaires</span>
                </h1>

                <!-- Bâtiment (aligné à droite comme bloc d’info de Vite) -->
                <div v-if="installation.batiment" class="hidden md:block">
                    <div class="text-right">
                        <span class="opacity-90">Bâtiment :</span>
                        <span class="text-white font-bold ml-1">{{ installation.batiment.nom }}</span>
                    </div>
                </div>
            </header>
        </div>

        <!-- Contenu principal avec fond dégradé + arrondi top -->
        <main class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <!-- Carte blanche principale -->
            <div class="m-2 shadow-2xl rounded-lg overflow-hidden mb-30">
                <div class="bg-white p-4">

                    <!-- Bâtiment (fallback mobile) -->
                    <div v-if="installation.batiment" class="md:hidden text-right mb-2">
                        <span>Bâtiment: </span>
                        <span class="text-secondary font-bold">{{ installation.batiment.nom }}</span>
                    </div>

                    <!-- Form -->
                    <form method="post" id="installation" class="space-y-4" @submit.prevent="sendForm()"
                        @input="updateForm">

                        <!-- Date mise en service -->
                        <div>
                            <label class="label" for="date_mise_en_service">Date mise en service <span class="text-alert">*</span></label>
                            <input id="date_mise_en_service" type="date" class="input"
                                v-model="newInformation.date_mise_en_service" :max="today"
                                @change="updateEntretienDate($event)" />
                        </div>

                        <!-- Grille 2 colonnes : DESP / Maintenance / Entretien (comme Vite) -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 mb-5">

                            <!-- ===== Bloc DESP (Oui / Non) ===== -->
                            <div class="mb-2 p-4">
                                <h3 class="text-lg font-medium mb-5 uppercase text-secondary">DESP</h3>

                                <!-- Libellé -->
                                <p class="label">Équipement soumis à la DESP ?</p>

                                <!-- Boutons Oui / Non -->
                                <div class="flex items-center space-x-4 mt-3">
                                    <!-- OUI -->
                                    <label class="inline-flex items-center">
                                        <input type="radio" name="desp_is_checked" class="hidden peer" :value="true"
                                            v-model="newInformation.desp.is_checked">
                                        <span
                                            class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                                            Oui
                                        </span>
                                    </label>

                                    <!-- NON -->
                                    <label class="inline-flex items-center">
                                        <input type="radio" name="desp_is_checked" class="hidden peer" :value="false"
                                            v-model="newInformation.desp.is_checked">
                                        <span
                                            class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                                            Non
                                        </span>
                                    </label>
                                </div>

                                <!-- Contenu DESP (affiché uniquement si OUI) -->
                                <div v-if="newInformation.desp.is_checked === true" class="space-y-4 mt-4">

                                    <div>
                                        <label class="label" for="desp_last_date">Inspection périodique réalisée
                                            le</label>
                                        <input id="desp_last_date" type="date" class="input"
                                            v-model="newInformation.desp.last_date" :max="today"
                                            @change="setDespLastDate($event)" />
                                    </div>

                                    <div>
                                        <label class="label" for="desp_alarm">Alarme</label>
                                        <select id="desp_alarm" class="input" v-model="newInformation.desp.alarm">
                                            <option value="0">Aucune</option>
                                            <option value="24">24 mois</option>
                                            <option value="48">48 mois</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label class="label" for="desp_commentaire">Commentaire</label>
                                        <textarea id="desp_commentaire" class="input"
                                            v-model="newInformation.desp.commentaire"></textarea>
                                    </div>

                                    <!-- Photo -->
                                    <div v-if="installation.i_tag !== null">
                                        <button type="button"
                                            class="bg-secondary text-white px-3 py-2 rounded flex items-center gap-2"
                                            @click="$refs.photoDESP.click()">
                                            <i class="inline-block h-6 w-6 mask mask-photo bg-white"></i>
                                            <span>Photographier le document</span>
                                        </button>

                                        <input type="file" ref="photoDESP" v-show="false"
                                            @change="handlePhotoInstallDESP" accept="image/*" />

                                        <div class="mt-4 flex justify-center"
                                            v-show="newInformation.desp.file !== null">
                                            <div class="relative">
                                                <i class="icon icon-delete absolute -top-2 -right-2 cursor-pointer"
                                                    @click="newInformation.desp.file = null"></i>
                                                <a :href="newInformation.desp.file" target="_blank">
                                                    <img :src="newInformation.desp.file" alt="photo installation"
                                                        class="max-h-64 rounded shadow" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- ===== Bloc Maintenance Préventive (Oui / Non) ===== -->
                            <div class="mb-2 p-4">
                                <h3 class="text-lg font-medium mb-5 uppercase text-secondary">
                                    Maintenance Préventive
                                </h3>

                                <!-- Libellé -->
                                <p class="label">Équipement soumis à une maintenance préventive ?</p>

                                <!-- Boutons Oui / Non -->
                                <div class="flex items-center space-x-4 mt-3">
                                    <!-- Oui -->
                                    <label class="inline-flex items-center">
                                        <input type="radio" name="maintenance_is_checked" class="hidden peer"
                                            :value="true" v-model="newInformation.maintenance.is_checked"
                                            @change="updateMaintenance">
                                        <span class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors
                                    peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                                            Oui
                                        </span>
                                    </label>

                                    <!-- Non -->
                                    <label class="inline-flex items-center">
                                        <input type="radio" name="maintenance_is_checked" class="hidden peer"
                                            :value="false" v-model="newInformation.maintenance.is_checked"
                                            @change="updateMaintenance">
                                        <span class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors
                                    peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                                            Non
                                        </span>
                                    </label>
                                </div>

                                <!-- Contenu affiché uniquement si Oui -->
                                <div v-if="newInformation.maintenance.is_checked === true" class="space-y-4 mt-4">

                                    <div>
                                        <label class="label" for="maintenance_last_date">
                                            Maintenance préventive réalisée le
                                        </label>
                                        <input id="maintenance_last_date" type="date" class="input"
                                            v-model="newInformation.maintenance.last_date" :max="today"
                                            @change="setMaintenanceLastDate($event)" />
                                    </div>

                                    <div>
                                        <label class="label" for="maintenance_alarm">Alarme</label>
                                        <select id="maintenance_alarm" class="input"
                                            v-model="newInformation.maintenance.alarm">
                                            <option value="0">Aucune</option>
                                            <option value="12">12 mois</option>
                                            <option value="18">18 mois</option>
                                            <option value="24">24 mois</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label class="label" for="maintenance_commentaire">Commentaire</label>
                                        <textarea id="maintenance_commentaire" class="input"
                                            v-model="newInformation.maintenance.commentaire"></textarea>
                                    </div>

                                    <!-- Photo -->
                                    <div v-if="installation.i_tag !== null">
                                        <button type="button"
                                            class="bg-secondary text-white px-3 py-2 rounded flex items-center gap-2"
                                            @click="$refs.photoMaintenance.click()">
                                            <i class="inline-block h-6 w-6 mask mask-photo bg-white"></i>
                                            <span>Photographier le document</span>
                                        </button>

                                        <input type="file" ref="photoMaintenance" v-show="false"
                                            @change="handlePhotoInstallMaintenance" accept="image/*" />

                                        <div class="mt-4 flex justify-center"
                                            v-show="newInformation.maintenance.file !== null">
                                            <div class="relative">
                                                <i class="icon icon-delete absolute -top-2 -right-2 cursor-pointer"
                                                    @click="newInformation.maintenance.file = null"></i>
                                                <a :href="newInformation.maintenance.file" target="_blank">
                                                    <img :src="newInformation.maintenance.file" alt="photo installation"
                                                        class="max-h-64 rounded shadow" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>


                            <!-- ===== Bloc Entretien (Oui / Non) ===== -->
                            <div class="mb-2 p-4">
                                <h3 class="text-lg font-medium mb-5 uppercase text-secondary">
                                    Entretien
                                </h3>

                                <!-- Libellé -->
                                <p class="label">Équipement soumis à l'attestation d'entretien 4kW à 70 kW ?</p>

                                <!-- Boutons Oui / Non -->
                                <div class="flex items-center space-x-4 mt-3">
                                    <!-- Oui -->
                                    <label class="inline-flex items-center">
                                        <input type="radio" name="attestation_is_checked" class="hidden peer"
                                            :value="true" v-model="newInformation.attestation.is_checked"
                                            @change="updateAttestation">
                                        <span class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors
         peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                                            Oui
                                        </span>
                                    </label>

                                    <!-- Non -->
                                    <label class="inline-flex items-center">
                                        <input type="radio" name="attestation_is_checked" class="hidden peer"
                                            :value="false" v-model="newInformation.attestation.is_checked"
                                            @change="updateAttestation">
                                        <span class="cursor-pointer border border-gray-300 text-gray-700 py-2 px-4 rounded transition-colors
         peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                                            Non
                                        </span>
                                    </label>
                                </div>

                                <!-- Contenu complet affiché uniquement si OUI -->
                                <div v-if="newInformation.attestation.is_checked === true" class="space-y-4 mt-4">

                                    <div>
                                        <label class="label" for="attestation_last_date">Date de l'attestation
                                            d'entretien</label>
                                        <input id="attestation_last_date" type="date" class="input"
                                            v-model="newInformation.attestation.last_date"
                                            @change="setAttestionLastDate($event)" />
                                    </div>

                                    <div>
                                        <label class="label" for="type_equipement">Type d'équipement</label>
                                        <select id="type_equipement" class="input"
                                            v-model="newInformation.attestation.type_equipement">
                                            <option v-for="type in listTypeEquipement" :key="type" :value="type">{{ type
                                                }}</option>
                                        </select>
                                    </div>

                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                                        <div>
                                            <label class="label" for="puissance_chaud">Puissance chaud (kW)</label>
                                            <input id="puissance_chaud" type="number" class="input"
                                                v-model="newInformation.attestation.puissance_chaud">
                                        </div>

                                        <div>
                                            <label class="label" for="puissance_froid">Puissance froid (kW)</label>
                                            <input id="puissance_froid" type="number" class="input"
                                                v-model="newInformation.attestation.puissance_froid">
                                        </div>
                                    </div>

                                    <div>
                                        <label class="label" for="attestation_commentaire">Commentaire</label>
                                        <textarea id="attestation_commentaire" class="input"
                                            v-model="newInformation.attestation.commentaire"></textarea>
                                    </div>

                                    <!-- Photo -->
                                    <div v-if="installation.i_tag !== null">
                                        <button type="button"
                                            class="bg-secondary text-white px-3 py-2 rounded flex items-center gap-2"
                                            @click="$refs.photoEntretien.click()">
                                            <i class="inline-block h-6 w-6 mask mask-photo bg-white"></i>
                                            <span>Photographier le document</span>
                                        </button>

                                        <input type="file" ref="photoEntretien" v-show="false"
                                            @change="handlePhotoInstallEntretien" accept="image/*" />

                                        <div class="mt-4 flex justify-center"
                                            v-show="newInformation.attestation.file !== null">
                                            <div class="relative">
                                                <i class="icon icon-delete absolute -top-2 -right-2 cursor-pointer"
                                                    @click="newInformation.attestation.file = null"></i>
                                                <a :href="newInformation.attestation.file" target="_blank">
                                                    <img :src="newInformation.attestation.file"
                                                        alt="photo attestation d'entretien"
                                                        class="max-h-64 rounded shadow" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>

                        <!-- Bouton Enregistrer -->
                        <input type="submit" id="install_infos_btn_save" value="Enregistrer" v-if="canEditInstallations"
                            class="btn-primary" />

                        <!-- Dernière saisie (style Vite) -->
                        <h2 class="text-lg font-medium mb-5 uppercase text-secondary">Dernière saisie :</h2>

                        <!-- DESP last -->
                        <div class="grid grid-cols-1 gap-2 mb-5"
                            v-if="lastInformation != null && lastInformation.desp.is_checked === true && installation.fluide !== null">
                            <div class="flex items-center gap-2 font-bold">
                                <i class="inline-block h-5 w-5 mask mask-check-circle bg-secondary"></i>
                                Équipement soumis à la DESP
                            </div>
                            <div>
                                Dernière inspection le :
                                <span class="text-secondary font-bold">{{ lastInformation.desp.last_date | dateFormat
                                }}</span>
                            </div>
                            <div>
                                Alarme :
                                <span class="text-secondary font-bold">{{ lastInformation.desp.alarm == 0 ? 'Aucune' :
                                    lastInformation.desp.alarm + ' mois' }}</span>
                            </div>
                            <div>
                                Commentaire :
                                <span class="text-secondary font-bold">{{ lastInformation.desp.commentaire }}</span>
                            </div>
                            <div>
                                <a v-if="lastInformation.desp.file != null && isBase64(lastInformation.desp.file) === false"
                                    :href="`${Config.urlAdmin}/upload/${lastInformation.desp.file}`" target="_blank"
                                    class="bg-success text-white px-3 py-2 rounded inline-flex items-center gap-2">
                                    <i class="inline-block h-5 w-5 mask mask-eye bg-white"></i>
                                    <span>Voir le document</span>
                                </a>
                                <img v-if="lastInformation.desp.file != null && isBase64(lastInformation.desp.file) === true"
                                    :src="lastInformation.desp.file" alt="photo installation"
                                    class="max-h-64 rounded shadow">
                                <span v-if="lastInformation.desp.file === null" class="text-secondary font-bold">Pas de
                                    document</span>
                            </div>
                        </div>

                        <!-- Maintenance last -->
                        <div class="grid grid-cols-1 gap-2 mb-5"
                            v-if="lastInformation != null && lastInformation.maintenance.is_checked === true">
                            <div class="flex items-center gap-2 font-bold">
                                <i class="inline-block h-5 w-5 mask mask-check-circle bg-secondary"></i>
                                Équipement soumis à la Maintenance Préventive
                            </div>
                            <div>
                                Maintenance préventive le :
                                <span class="text-secondary font-bold">{{ lastInformation.maintenance.last_date |
                                    dateFormat }}</span>
                            </div>
                            <div>
                                Alarme :
                                <span class="text-secondary font-bold">{{ lastInformation.maintenance.alarm == 0 ?
                                    'Aucune' : lastInformation.maintenance.alarm + ' mois' }}</span>
                            </div>
                            <div>
                                Commentaire :
                                <span class="text-secondary font-bold">{{ lastInformation.maintenance.commentaire
                                }}</span>
                            </div>
                            <div>
                                <a v-if="lastInformation.maintenance.file != null && isBase64(lastInformation.maintenance.file) === false"
                                    :href="`${Config.urlAdmin}/upload/${lastInformation.maintenance.file}`"
                                    target="_blank"
                                    class="bg-success text-white px-3 py-2 rounded inline-flex items-center gap-2">
                                    <i class="inline-block h-5 w-5 mask mask-eye bg-white"></i>
                                    <span>Voir le document</span>
                                </a>
                                <img v-if="lastInformation.maintenance.file != null && isBase64(lastInformation.maintenance.file) === true"
                                    :src="lastInformation.maintenance.file" alt="photo installation"
                                    class="max-h-64 rounded shadow">
                                <span v-if="lastInformation.maintenance.file === null"
                                    class="text-secondary font-bold">Pas de document</span>
                            </div>
                        </div>

                        <!-- Entretien last -->
                        <div class="grid grid-cols-1 gap-2 mb-5"
                            v-if="lastInformation != null && lastInformation.attestation.is_checked === true && installation.fluide !== null">
                            <div class="flex items-center gap-2 font-bold">
                                <i class="inline-block h-5 w-5 mask mask-check-circle bg-secondary"></i>
                                Équipement soumis à l'attestation d'entretien
                            </div>
                            <div>
                                Attestation d'entretien le :
                                <span class="text-secondary font-bold">{{ lastInformation.attestation.last_date |
                                    dateFormat }}</span>
                            </div>
                            <div>
                                Type :
                                <span class="text-secondary font-bold">{{ lastInformation.attestation.type_equipement
                                }}</span>
                            </div>
                            <div v-if="lastInformation.attestation.puissance_chaud">
                                Puissance chaud :
                                <span class="text-secondary font-bold">{{ lastInformation.attestation.puissance_chaud }}
                                    kW</span>
                            </div>
                            <div v-if="lastInformation.attestation.puissance_froid">
                                Puissance froid :
                                <span class="text-secondary font-bold">{{ lastInformation.attestation.puissance_froid }}
                                    kW</span>
                            </div>
                            <div>
                                Commentaire :
                                <span class="text-secondary font-bold">{{ lastInformation.attestation.commentaire
                                }}</span>
                            </div>
                            <div>
                                <a v-if="lastInformation.attestation.file != null && isBase64(lastInformation.attestation.file) === false"
                                    :href="`${Config.urlAdmin}/upload/${lastInformation.attestation.file}`"
                                    target="_blank"
                                    class="bg-success text-white px-3 py-2 rounded inline-flex items-center gap-2">
                                    <i class="inline-block h-5 w-5 mask mask-eye bg-white"></i>
                                    <span>Voir le document</span>
                                </a>
                                <img v-if="lastInformation.attestation.file != null && isBase64(lastInformation.attestation.file) === true"
                                    :src="lastInformation.attestation.file" alt="photo attestation d'entretien"
                                    class="max-h-64 rounded shadow">
                                <span v-if="lastInformation.attestation.file === null"
                                    class="text-secondary font-bold">Pas de document</span>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </main>
    </main-layout>
</template>


<script>
import Installation from '../../js/models/Installation'
import moment from "moment";
import Config from "../../js/config";
import InformationInstallation from "../../js/models/InformationInstallation";
import loadImage from "blueimp-load-image";
import { install } from "offline-plugin/runtime";
import Operateur from "@/js/models/Operateur";

export default {
    data() {
        return {
            installation: {
                information: {}
            },
            lastInformation: {
                date_mise_en_service: null,
                installation: null,
                desp: {
                    is_checked: false,
                    last_date: null,
                    alarm: 0,
                    commentaire: null,
                    file: null
                },
                maintenance: {
                    is_checked: false,
                    last_date: null,
                    alarm: 0,
                    commentaire: null,
                    file: null
                },
                attestation: {
                    is_checked: false,
                    last_date: null,
                    type_equipement: null,
                    puissance_froid: null,
                    puissance_chaud: null,
                    commentaire: null,
                    file: null
                }
            },
            newInformation: {
                date_mise_en_service: null,
                installation: null,
                desp: {
                    is_checked: false,
                    last_date: null,
                    alarm: 0,
                    commentaire: null,
                    file: null
                },
                maintenance: {
                    is_checked: false,
                    last_date: null,
                    alarm: 0,
                    commentaire: null,
                    file: null
                },
                attestation: {
                    is_checked: false,
                    last_date: null,
                    type_equipement: null,
                    puissance_froid: null,
                    puissance_chaud: null,
                    commentaire: null,
                    file: null
                }
            },
            display: {
                desp: false,
                maintenance: false,
                attestation: false
            },
            cache: {
                inCache: false,
                id: null
            },
            canEditInstallations: null,
            today: moment().format('Y-MM-DD'),
            formModified: false,
            listTypeEquipement: null
        }
    },

    computed: {
        Config() {
            return Config
        },
    },

    methods: {
        install,

        validateForm() {
            let errors = [];

            let newInformation = this.newInformation;

            if (newInformation.desp.is_checked === true) {

                if (!newInformation.desp.last_date || !newInformation.desp.alarm) {
                    errors.push('<strong>DESP :</strong>');
                }

                if (!newInformation.desp.last_date) {
                    errors.push('la date de la dernière inspection périodique est obligatoire');
                }

                if (!newInformation.desp.alarm) {
                    errors.push('l\'alarme est obligatoire');
                }

            } else {
                newInformation.desp.is_checked = false;
                newInformation.desp.last_date = null;
                newInformation.desp.alarm = null;
                newInformation.desp.commentaire = null;
                newInformation.desp.file = null;
            }


            if (newInformation.maintenance.is_checked === true) {

                if (!newInformation.maintenance.last_date || !newInformation.maintenance.alarm) {
                    errors.push('<strong>Maintenance préventive :</strong>');
                }

                if (!newInformation.maintenance.last_date) {
                    errors.push('Veuillez renseigner la date de la dernière maintenance préventive');
                }

                if (!newInformation.maintenance.alarm) {
                    errors.push('Veuillez renseigner l\'alarme');
                }

            } else {
                newInformation.maintenance.is_checked = false;
                newInformation.maintenance.last_date = null;
                newInformation.maintenance.alarm = null;
                newInformation.maintenance.commentaire = null;
                newInformation.maintenance.file = null;
            }


            if (newInformation.attestation.is_checked === true) {

                if (!newInformation.attestation.last_date || !newInformation.attestation.type_equipement || !newInformation.attestation.puissance_froid || !newInformation.attestation.puissance_chaud) {
                    errors.push('<strong>Attestation d\'entretien :</strong>');
                }

                if (!newInformation.attestation.last_date) {
                    errors.push('Veuillez renseigner la date de l\'attestation d\'entretien');
                }

                if (!newInformation.attestation.type_equipement) {
                    errors.push('Veuillez renseigner le type d\'équipement');
                }

                if (!newInformation.attestation.puissance_froid) {
                    errors.push('Veuillez renseigner la puissance froid');
                }

                if (!newInformation.attestation.puissance_chaud) {
                    errors.push('Veuillez renseigner la puissance chaud');
                }
            } else {
                newInformation.attestation.is_checked = false;
                newInformation.attestation.last_date = null;
                newInformation.attestation.type_equipement = null;
                newInformation.attestation.puissance_froid = null;
                newInformation.attestation.puissance_chaud = null;
                newInformation.attestation.commentaire = null;
                newInformation.attestation.file = null;
            }

            newInformation.installation = this.installation.id;

            if (this.cache.inCache === true) {
                newInformation.id = this.cache.id;
            }

            return {
                errors: errors,
                newInformation: newInformation
            }
        },

        sendForm() {
            let _router = this.$router;
            let vue = this;
            let idDet = this.$route.params.id;

            let validate = this.validateForm();
            let errors = validate.errors;
            let newInformation = validate.newInformation;

            if (errors.length !== 0) {
                let text = errors.join('<br>');
                swal('Information(s) manquante(s) :', 'Veuillez renseigner <br>' + text + '.', 'error')
            } else {
                InformationInstallation
                    .addInformationInstallationOffline(newInformation)
                    .then(function () {
                        swal('Succès', 'La saisie a bien été enregistrée', 'success').then(() => {
                            //Comme le formulaire est enregistrer, on va pas mettre la popup qui dit gneugneu enregistre :clown:
                            vue.formModified = false;
                            _router.push({ name: "installation", params: { id: idDet, idInst: newInformation.installation } })
                        })
                    })
            }
        },

        updateForm() {
            this.formModified = true;
        },

        handlePhotoInstallDESP(e) {
            let vueInstance = this;

            loadImage(
                e.target.files[0],
                function (img) {
                    vueInstance.newInformation.desp.file = img.toDataURL();
                },
                {
                    maxWidth: 700,
                    maxHeight: 700,
                    orientation: true,
                    canvas: true
                }
            )

        },

        isBase64(str) {
            if (str === null) {
                return false;
            }
            return str.startsWith('data:');
        },

        handlePhotoInstallMaintenance(e) {
            let vueInstance = this;

            loadImage(
                e.target.files[0],
                function (img) {
                    vueInstance.newInformation.maintenance.file = img.toDataURL();
                },
                {
                    maxWidth: 700,
                    maxHeight: 700,
                    orientation: true,
                    canvas: true
                }
            )

        },

        handlePhotoInstallEntretien(e) {
            let vueInstance = this;

            loadImage(
                e.target.files[0],
                function (img) {
                    vueInstance.newInformation.attestation.file = img.toDataURL();
                },
                {
                    maxWidth: 700,
                    maxHeight: 700,
                    orientation: true,
                    canvas: true
                }
            )

        },

        updateDisplay(type) {
            if (type === "desp") {
                this.display.desp = true;
                this.newInformation.desp.is_checked = true;
            } else if (type === "maintenance") {
                this.display.maintenance = true;
                this.newInformation.maintenance.is_checked = true;
            } else if (type === "attestation") {
                this.display.attestation = true;
                this.newInformation.attestation.is_checked = true;
                this.newInformation.attestation.last_date = this.newInformation.date_mise_en_service
            }
        },

        updateDesp() {
            if (this.newInformation.desp.is_checked === false) {
                this.display.desp = false;
            }

            if (this.newInformation.desp.is_checked === true) {
                this.display.desp = true;
            }
        },

        updateMaintenance() {
            if (this.newInformation.maintenance.is_checked === false) {
                this.display.maintenance = false;
            }

            if (this.newInformation.maintenance.is_checked === true) {
                this.display.maintenance = true;
            }
        },

        updateAttestation() {
            if (this.newInformation.attestation.is_checked === false) {
                this.display.attestation = false;
            }

            if (this.newInformation.attestation.is_checked === true) {
                this.display.attestation = true;
            }
        },

        updateEntretienDate(event) {
            const inputValue = event.target.value;
            this.newInformation.date_mise_en_service = inputValue;
            this.newInformation.attestation.last_date = this.newInformation.date_mise_en_service;
        },
        setDespLastDate(event) {
            const inputValue = event.target.value;
            this.newInformation.desp.last_date = inputValue;
        },
        setMaintenanceLastDate(event) {
            const inputValue = event.target.value;
            this.newInformation.maintenance.last_date = inputValue;
        },
        setAttestionLastDate(event) {
            const inputValue = event.target.value;
            this.newInformation.attestation.last_date = inputValue;
        },

        fetchInstallation() {

            return new Promise((resolve, reject) => {
                let vueInstance = this;
                let idInstall = this.$route.params.idInst;

                Installation
                    .getInstallation(idInstall)
                    .then(res => {
                        vueInstance.installation = res;

                        InformationInstallation
                            .getListByInstallation(res.id)
                            .then(function (result) {



                                if (!_.isEmpty(result)) {
                                    //first key array
                                    result = result.pop()


                                    vueInstance.newInformation.date_mise_en_service = moment(result.date_mise_en_service).format('YYYY-MM-DD');

                                    vueInstance.newInformation.desp.is_checked = result.desp.is_checked
                                    vueInstance.newInformation.desp.alarm = result.desp.alarm;
                                    vueInstance.newInformation.desp.last_date = moment(result.desp.last_date).format('YYYY-MM-DD');
                                    vueInstance.newInformation.desp.commentaire = result.desp.commentaire;
                                    vueInstance.newInformation.desp.file = result.desp.file;

                                    vueInstance.newInformation.maintenance.is_checked = result.maintenance.is_checked;
                                    vueInstance.newInformation.maintenance.last_date = moment(result.maintenance.last_date).format('YYYY-MM-DD');
                                    vueInstance.newInformation.maintenance.alarm = result.maintenance.alarm;
                                    vueInstance.newInformation.maintenance.commentaire = result.maintenance.commentaire;
                                    vueInstance.newInformation.maintenance.file = result.maintenance.file;

                                    vueInstance.newInformation.attestation.is_checked = result.attestation.is_checked;
                                    vueInstance.newInformation.attestation.last_date = moment(result.attestation.last_date).format('YYYY-MM-DD');
                                    vueInstance.newInformation.attestation.type_equipement = result.attestation.type_equipement;
                                    vueInstance.newInformation.attestation.puissance_froid = result.attestation.puissance_froid;
                                    vueInstance.newInformation.attestation.puissance_chaud = result.attestation.puissance_chaud;
                                    vueInstance.newInformation.attestation.commentaire = result.attestation.commentaire;
                                    vueInstance.newInformation.attestation.file = result.attestation.file;

                                    vueInstance.cache.inCache = true;
                                    vueInstance.cache.id = result.id;
                                    //Cache l'historique si on a du local
                                    vueInstance.lastInformation = null;

                                } else {
                                    vueInstance.installation.information = {};

                                    let isFirst = {
                                        'desp': true,
                                        'maintenance': true,
                                        'attestation': true
                                    };

                                    vueInstance.newInformation.date_mise_en_service = moment(vueInstance.installation.date_mise_en_service).format('YYYY-MM-DD');


                                    let item = null;

                                    if (vueInstance.installation.last_information_desp) {
                                        item = vueInstance.installation.last_information_desp;

                                        vueInstance.newInformation.desp.is_checked = item.is_checked;
                                        vueInstance.newInformation.desp.last_date = moment(item.last_date).format('YYYY-MM-DD');
                                        vueInstance.newInformation.desp.alarm = item.alarm;

                                        vueInstance.lastInformation.desp.is_checked = item.is_checked;
                                        vueInstance.lastInformation.desp.last_date = moment(item.last_date).format('YYYY-MM-DD');
                                        vueInstance.lastInformation.desp.alarm = item.alarm;
                                        vueInstance.lastInformation.desp.commentaire = item.commentaire;
                                        vueInstance.lastInformation.desp.file = item.file;
                                    }

                                    if (vueInstance.installation.last_information_maintenance) {
                                        item = vueInstance.installation.last_information_maintenance;

                                        vueInstance.newInformation.maintenance.is_checked = item.is_checked;
                                        vueInstance.newInformation.maintenance.last_date = moment(item.last_date).format('YYYY-MM-DD');
                                        vueInstance.newInformation.maintenance.alarm = item.alarm;

                                        vueInstance.lastInformation.maintenance.is_checked = item.is_checked;
                                        vueInstance.lastInformation.maintenance.last_date = moment(item.last_date).format('YYYY-MM-DD');
                                        vueInstance.lastInformation.maintenance.alarm = item.alarm;
                                        vueInstance.lastInformation.maintenance.commentaire = item.commentaire;
                                        vueInstance.lastInformation.maintenance.file = item.file;
                                    }

                                    if (vueInstance.installation.last_information_attestation) {
                                        item = vueInstance.installation.last_information_attestation;

                                        vueInstance.newInformation.attestation.is_checked = item.is_checked;
                                        vueInstance.newInformation.attestation.last_date = moment(item.last_date).format('YYYY-MM-DD');
                                        vueInstance.newInformation.attestation.type_equipement = item.type_equipement;
                                        vueInstance.newInformation.attestation.puissance_froid = item.puissance_froid;
                                        vueInstance.newInformation.attestation.puissance_chaud = item.puissance_chaud;

                                        vueInstance.lastInformation.attestation.is_checked = item.is_checked;
                                        vueInstance.lastInformation.attestation.last_date = moment(item.last_date).format('YYYY-MM-DD');
                                        vueInstance.lastInformation.attestation.type_equipement = item.type_equipement;
                                        vueInstance.lastInformation.attestation.puissance_froid = item.puissance_froid;
                                        vueInstance.lastInformation.attestation.puissance_chaud = item.puissance_chaud;
                                        vueInstance.lastInformation.attestation.commentaire = item.commentaire;
                                        vueInstance.lastInformation.attestation.file = item.file;
                                    }



                                }
                            }).then(() => {
                                resolve(true)
                            })
                    })
                    .catch(() => {
                        reject('error')
                    })
            })


        },
    },

    beforeRouteLeave(to, from, next) {
        if (this.formModified) {
            // Des modifications non enregistrées ont été détectées, affichez la boîte de dialogue de confirmation

            swal({
                title: 'Des modifications non enregistrées ont été détectées.',
                text: "Voulez-vous enregistrer les modifications avant de quitter la page ?",
                type: 'question',
                confirmButtonText: 'Oui',
                showCancelButton: true,
                cancelButtonText: 'Non',
                allowOutsideClick: false
            }).then(
                () => {
                    if (this.validateForm().errors.length === 0) {
                        this.sendForm();
                        next();
                    } else {
                        swal('Information(s) manquante(s) :', 'Veuillez renseigner <br>' + this.validateForm().errors.join('<br>') + '.', 'error');
                        next(false);
                    }
                },
                () => {
                    next()
                }
            )
            next(false);
        } else {
            // Aucune modification détectée, poursuivez la navigation
            next();
        }
    },

    mounted: function () {

        this.canEditInstallations = JSON.parse(localStorage.getItem('canEditInstallations'));
        localforage
            .getItem('listTypesEntretien')
            .then((value) => {
                this.listTypeEquipement = JSON.parse(value);

            })

        this.fetchInstallation().then(() => {

            if (this.installation.fluide === null) {
                //Don't display desp ou attestation si pas de fluide dans install :)
                this.display.attestation = false;
                this.newInformation.attestation.is_checked = false;
                this.display.desp = false;
                this.newInformation.desp.is_checked = false;

            }
            this.updateDesp();
            this.updateMaintenance();
            this.updateAttestation();

        })

    }
}
</script>

<style>
@import '~leaflet/dist/leaflet.css';
</style>



// WEBPACK FOOTER //
// InformationInstallation.vue?45de7389